import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NewAnswerModalContentContainer } from '../NewAnswerModalContent';
import { setNewAnswerFormClose } from '../../actions/newAnswer/openFormActions';
import { getIsLastAnswerFormStep, getIsOpen } from '../../selectors/newAnswer';
import { NewAnswerFooterContainer } from '../NewAnswer';
import { getAnswerTargetId } from '../../selectors/common';
import { FormModalLayout } from '../../components/FormLayout';

export const NewAnswerModalContainer = (): React.JSX.Element | null => {
  const dispatch = useDispatch();
  const openId = useSelector(getIsOpen);
  const isLastStep = useSelector(getIsLastAnswerFormStep);
  const targetId = useSelector(getAnswerTargetId(openId));

  const onClose = React.useCallback(() => {
    dispatch(setNewAnswerFormClose());
  }, []);

  if (!openId) {
    return null;
  }

  return (
    <FormModalLayout
      title="Новый ответ"
      shortTitle="Новый ответ"
      footer={<NewAnswerFooterContainer reviewId={targetId} type={openId.type} />}
      onClose={onClose}
      type={isLastStep ? 'info' : 'form'}
      open={!!openId}
      testId="NewAnswer"
    >
      <NewAnswerModalContentContainer onClose={onClose} />
    </FormModalLayout>
  );
};
